import { useMemo } from 'react';

import ColumnFilterRoot from './ColumnFilterRoot';
import ColumnFilterCell from './ColumnFilterCell';
import { Group } from 'react-konva';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';

import { getColumnRootX } from '../../../helpers/gridBoundariesHelpers';
import { UseFilterDropdown } from '../../../hooks/useFilterDropdown';
import { getColumnsCellView } from '../../../helpers/cellView/cellColumns';
import { ColumnCellView } from '../../../helpers/cellView/cellViewTypes';
import { UseKonvaCursor } from '../../../../core/hooks/useKonvaCursor';

interface ColumnFilterProps
  extends UseKonvaCursor,
    Pick<UseFilterDropdown, 'openFilterDropdown'>,
    ReturnTypeofSheetSectionsSelector,
    Pick<
      UseSheetTheme,
      | 'isRtl'
      | 'fill'
      | 'secondaryFill'
      | 'stroke'
      | 'textColor'
      | 'filterAppliedFill'
      | 'isDarkTheme'
    > {
  sheetId: string;
  gridWidth: number;
}

const ColumnFilter: React.FC<ColumnFilterProps> = (props) => {
  const {
    gridWidth,
    sheetId,
    // viewport,

    colViewport,

    defaultColWidth,
    rowHeaderWidth,
    // groupBarHeight,
    colHeaderHeight,
    colFilterHeight,
    freezedCols,
    freezedColsSum,

    isRtl,
    fill,
    stroke,
    secondaryFill,
    textColor,
    filterAppliedFill,

    zoom,
    onMouseEnter,
    onMouseLeave,
  } = props;
  // #region views

  const renderFilter = ({ ci, width, x }: ColumnCellView) => (
    <ColumnFilterCell
      key={`${sheetId}-filter-${ci}`}
      x={x}
      y={colHeaderHeight} // groupBarHeight +
      width={width}
      height={colFilterHeight}
      index={ci}
      zoom={zoom}
      isRtl={isRtl}
      fill={fill}
      stroke={stroke}
      secondaryFill={secondaryFill}
      textColor={textColor}
      filterAppliedFill={filterAppliedFill}
      openFilterDropdown={props.openFilterDropdown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );

  const renderFilterRoot = () => (
    <ColumnFilterRoot
      key={`${sheetId}-filter-root`}
      x={getColumnRootX(0, gridWidth, rowHeaderWidth, isRtl)}
      y={colHeaderHeight} // +groupBarHeight
      width={rowHeaderWidth}
      height={colFilterHeight}
      stroke={stroke}
      secondaryFill={secondaryFill}
    />
  );

  const Filters = useMemo(() => {
    if (colFilterHeight <= 0) return null;

    const Filters = getColumnsCellView(props, renderFilter);

    Filters.push(renderFilterRoot());

    return Filters;
  }, [
    // zoom,

    isRtl,
    // cols,

    colViewport,

    // defaultColWidth,
    // rowHeaderWidth,
    // colHeaderHeight,
    // colFilterHeight,

    // freezedCols,
    // freezedColsSum,
    gridWidth,

    props.isDarkTheme,
    // fill,
    // stroke,
    // secondaryFill,
    // textColor,
    // filterAppliedFill,
  ]);

  return <Group>{Filters}</Group>;
};

export default ColumnFilter;
